//@flow

import {ActionCreator, createReducer} from '../../../store/utils';

export type RealTimeMultichatStatus =
  | 'CONNECTING'
  | 'CONNECTED'
  | 'DISCONNECTED'
  | 'ERROR';

export const CONNECTION_STATUS = {
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
};

export type RealTimeMultichatState = {
  token: string,
  error: string | null,
  listening: boolean,
  connecting: boolean,
  status: RealTimeMultichatStatus,
};

export type RealTimeMultichatAction = {
  token?: string,
  error?: string | null,
  listening?: boolean,
  connecting?: boolean,
};

export const initialState: RealTimeMultichatState = {
  token: '',
  error: null,
  listening: false,
  connecting: false,
  status: 'DISCONNECTED',
};

export class SetToken extends ActionCreator<RealTimeMultichatAction> {}
export class SetError extends ActionCreator<RealTimeMultichatAction> {}
export class SetListening extends ActionCreator<RealTimeMultichatAction> {}
export class SetConnecting extends ActionCreator<RealTimeMultichatAction> {}
export class SetConnectionStatus extends ActionCreator<RealTimeMultichatAction> {}

export const actions = {
  setToken: (token: string) => new SetToken({token}),
  setError: (error: string | null) => new SetError({error}),
  setListening: (listening: boolean) => new SetListening({listening}),
  setConnecting: (connecting: boolean) => new SetConnecting({connecting}),
  setConnectionStatus: (status: RealTimeMultichatStatus) =>
    new SetConnectionStatus({status}),
};

export default createReducer<RealTimeMultichatState>(initialState, {
  [SetToken.type]: (state, {token}) => ({
    ...state,
    token: token || '',
  }),
  [SetError.type]: (state, {error}) => ({
    ...state,
    error: error || null,
  }),
  [SetListening.type]: (state, {listening}) => ({
    ...state,
    listening: listening || false,
  }),
  [SetConnecting.type]: (state, {connecting}) => ({
    ...state,
    connecting: connecting || false,
  }),
  [SetConnectionStatus.type]: (state, {status}) => ({
    ...state,
    status: status || 'DISCONNECTED',
  }),
});
